import React from 'react';
import {} from 'react-bootstrap';
import ReloadButton from '../LoadingButtons/ReloadButton';

const GroupFilter = ({ activeTab, setActiveTab, onRefresh, isLoading }) => {
  
  const tabs = [
    { id: 'Yeni', label: 'Yeni' },
    { id: 'Aktiv', label: 'Aktiv' },
    { id: 'Fasilə', label: 'Fasilə' },
    { id: 'Passiv', label: 'Passiv' },
    { id: 'Məzun', label: 'Məzun' }
  ];

  const handleTabClick = (tabId) => {
    
    if (tabId === activeTab || isLoading) return;
    
    
    
    setActiveTab(tabId);
  };

  const getButtonStyle = (id, index) => {
    const isActive = activeTab === id;

    return {
      backgroundColor: isActive ? 'var(--success-color, #10b981)' : '#fff',
      color: isActive ? '#fff' : '#374151',
      border: '1px solid #dee2e6',
      fontSize: '12px',
      padding: '8px 16px',
      fontWeight: '600',
      minWidth: '85px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTopLeftRadius: index === 0 ? '6px' : '0',
      borderBottomLeftRadius: index === 0 ? '6px' : '0',
      borderTopRightRadius: index === tabs.length - 1 ? '6px' : '0',
      borderBottomRightRadius: index === tabs.length - 1 ? '6px' : '0',
      marginLeft: index === 0 ? '0' : '-1px',
      transition: 'all 0.2s ease',
      cursor: isLoading ? 'not-allowed' : 'pointer',
      outline: 'none',
    };
  };

  return (
    <div className="d-flex align-items-center flex-wrap gap-3 mb-3">
      {/* Qruplar Başlığı */}
      <div className="d-flex align-items-center bg-light px-3 py-1 rounded-pill border shadow-sm">
        <span style={{ fontSize: '13px', fontWeight: '700' }}>Qruplar</span>
      </div>

      {/* Düymələr */}
      <div className="d-inline-flex shadow-sm rounded">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => handleTabClick(tab.id)}
            style={getButtonStyle(tab.id, index)}
            disabled={isLoading}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Refresh — sağda */}
      <div style={{ marginLeft: 'auto' }}>
        <ReloadButton onClick={onRefresh} loading={isLoading} />
      </div>
    </div>
  );
};

export default GroupFilter;